module.exports = __webpack_public_path__ + "static/measure-distance2-cd179e4853a26e40b3503aeedf20ecec.mp4";